import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function search (parametro) {
  return sessaoFetch(`base`, `/pedido/list/search?q=${parametro}`)
}

export async function searchNovo (parametro) {
  return sessaoFetch(`consig`, `/pedidos/BuscarPedidos?q=${parametro}`)
}

export async function origemTree () {
  return sessaoFetch(`base`, `/pedido/origem/tree`)
}

export async function novo (parametro) {
  return sessaoFetchLoading(`base`, '/pedido/novo', 'POST', parametro)
}

export async function novoCNPJ (parametro) {
  return sessaoFetchLoading(`base`, '/pedido/novoCNPJ', 'POST', parametro)
}

export async function novoTelefone (parametro) {
  return sessaoFetchLoading(`base`, '/pedido/novoTelefone', 'POST', parametro)
}

export async function novoCsharp (parametro) {
  return sessaoFetchLoading(`consig`, '/pedidos/criar', 'POST', parametro)
}

export async function get (id) {
  return sessaoFetchLoading(`base`, `/pedido/${id}`)
}

export async function salvarLeed (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/leed`, 'POST', dados)
}

export async function editaEntidade (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade`, 'PUT', dados)
}

export async function getTelefones (id) {
  return sessaoFetch(`base`, `/pedido/${id}/telefones`, 'GET')
}

export async function editaEmails (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/emails`, 'PUT', dados)
}

export async function editaTelefones (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/telefones`, 'PUT', dados)
}

export async function editaEnderecos (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/enderecos`, 'PUT', dados)
}

export async function editaVeiculos (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/veiculos`, 'PUT', dados)
}

export async function editaEmpregos (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/empregos`, 'PUT', dados)
}

export async function editaEmpresas (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/empresas`, 'PUT', dados)
}

export async function editaSocios (id, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/entidade/socios`, 'PUT', dados)
}

export async function agendar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/agendar`, 'POST', dados)
}

export async function salvar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/salvar`, 'POST', dados)
}

export async function agendarRapido (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/agendar/rapido`, 'POST', dados)
}

export async function historicoEmail (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/historico/email`, 'POST', dados)
}

export async function historicoWhats (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/historico/whatsapp`, 'POST', dados)
}

export async function historicoSMS (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/historico/sms`, 'POST', dados)
}

export async function editaItens (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/itens`, 'PUT', dados)
}

export async function getItens (id) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/itens`, 'GET')
}

export async function getItensReabre (id) {
  return sessaoFetch(`base`, `/pedido/${id}/itens`, 'GET')
}

export async function editaItensINSS (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/inss/itens/${dados.beneficio.beneficio}`, 'PUT', dados)
}

export async function motivos (id) {
  return sessaoFetch(`base`, `/pedido/${id}/motivos?all=1`, 'GET')
}

export async function motivosItens (id, item) {
  return sessaoFetch(`base`, `/pedido/${id}/motivos?item_id=${item}&all=1`, 'GET')
}

export async function descartar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/recusar`, 'PUT', dados)
}

export async function descartarTelemarketing (id, dados) {
  return sessaoFetchLoading(`consig`, `/pedidos/${id}/descarteTelemarketing`, 'PUT', dados)
}

export async function finalizar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/finalizar`, 'PUT')
}

export async function reagendar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/reagendar`, 'PUT', dados)
}

export async function agendarFechamento (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/agendar/fechamento`, 'POST', dados)
}

export async function futuros (id, dados) {
  let query = ''
  if (dados.valor) query = `?valor=${dados.valor}`
  return sessaoFetchLoading(`base`, `/pedido/${id}/futuro${query}`, 'GET')
}

export async function getOportunidades () {
  return sessaoFetchLoading('base', '/pedido/list/oportunidade')
}

export async function listAgendadosTipo (parametros) {
  let query = `?classificacao=${parametros.classificacao}&all=1`

  if (parametros.nome) query += `&nome=${parametros.nome}`
  if (parametros.dataIni) query += `&data_agendamento_ini=${parametros.dataIni}`
  if (parametros.dataFim) query += `&data_agendamento_fim=${parametros.dataFim}`
  return sessaoFetchLoading(`base`, `/pedido/list/agendado${query}`)
}

export async function listAgendadosOutroTipo (parametros) {
  let query = `?classificacao=${parametros.classificacao}&all=1`

  if (parametros.nome) query += `&nome=${parametros.nome}`
  if (parametros.dataIni) query += `&data_agendamento_ini=${parametros.dataIni}`
  if (parametros.dataFim) query += `&data_agendamento_fim=${parametros.dataFim}`
  return sessaoFetchLoading(`base`, `/pedido/list/agendado/outro${query}`)
}

export async function getOportunidadesTipo (parametros) {
  let query = `?classificacao=${parametros.classificacao}&all=1`

  if (parametros.nome) query += `&nome=${parametros.nome}`
  if (parametros.dataIni) query += `&data_agendamento_ini=${parametros.dataIni}`
  if (parametros.dataFim) query += `&data_agendamento_fim=${parametros.dataFim}`
  return sessaoFetchLoading(`base`, `/pedido/list/oportunidade${query}`)
}

export async function listPedidosLanca (parametros) {
  let query = `?`
  if (parametros.nome) query += `nome=${parametros.nome}&`
  if (parametros.data_inicial) query += `data_inicial=${parametros.data_inicial}&`
  if (parametros.data_final) query += `data_final=${parametros.data_final}&`
  return sessaoFetchLoading(`base`, `/pedido/list/finalizado${query}`)
}

export async function getOportunidadesLanca (parametros = {}) {
  let query = `?`
  if (parametros.data_inicial) query += `data_inicial=${parametros.data_inicial}&`
  if (parametros.data_final) query += `data_final=${parametros.data_final}&`
  if (parametros.nome) query += `nome=${parametros.nome}&`
  return sessaoFetchLoading(`base`, `/pedido/list/oportunidade/finalizado${query}`)
}

export async function listPedidosNovos (parametros) {
  let query = `?all=1`

  if (parametros.nome) query += `&nome=${parametros.nome}`
  return sessaoFetchLoading(`base`, `/pedido/list/novo${query}`)
}

export async function listLeads (parametros) {
  let query = ``
  if (parametros.nome) query += `?nome=${parametros.nome}`
  return sessaoFetchLoading(`consig`, `/leads/ListarTodosEnvelopado${query}`)
}

export async function getOportunidadeLead () {
  return sessaoFetchLoading(`consig`, `/leads/novo`)
}

export async function getOportunidadesNovos (parametros = {}) {
  let query = `?all=1`

  if (parametros.nome) query += `&nome=${parametros.nome}`
  return sessaoFetchLoading(`base`, `/pedido/list/oportunidade/novo${query}`)
}

export async function getOportunidadesLeads (parametros = {}) {
  let query = ``
  if (parametros.nome) query += `?nome=${parametros.nome}`
  return sessaoFetchLoading(`consig`, `/leads/OportunidadesQuery${query}`)
}

export async function getPossibilidades (dados) {
  return sessaoFetch(`base`, `/pedido/inss/possibilidades?` + serialize(dados), 'GET')
}

export async function listagemPedido (id) {
  return sessaoFetch(`base`, `/pedido/listagem/${id}`, 'POST')
}

export async function setPedidoAtendimento (id) {
  return sessaoFetch(`base`, `/pedido/${id}/andamento`, 'POST')
}

export async function getPedidoAtendimento (id) {
  return sessaoFetch(`base`, `/pedido/andamento`, 'GET')
}

export async function inativaPedidoAtendimento (id) {
  return sessaoFetch(`base`, `/pedido/andamento`, 'PUT')
}

export async function getHistAtendimentos (dados) {
  return sessaoFetch(`consig`, `/pedidos/ListarPaginadoEnvelopado?` + serialize(dados), 'GET')
}
/* export async function getHistAtendimentos (dados) {
  return sessaoFetch(`base`, `/pedido/list/andamento?` + serialize(dados), 'GET')
} */

export async function mudaVendaDigital (dados) {
  return sessaoFetch(`base`, `/pedido/mudaVendaDigital`, 'PUT', dados)
}

export async function validaProposta (dados) {
  return sessaoFetch(`base`, `/pedido/validaProposta`, 'PUT', dados)
}

export async function desvalidaProposta (dados) {
  return sessaoFetch(`base`, `/pedido/desvalidaProposta`, 'PUT', dados)
}

export async function dataCalculado (id) {
  return sessaoFetch(`base`, `/pedido/datacalculado/${id}`, 'GET')
}

export async function atualizaBeneficioContratos ({ entidade_id: entidadeId }) {
  // const ex = () => { throw new Error('Não foi possível consultar a API de atualização de contratos, serão usados os dados que já estão no sistema') }

  return sessaoFetchLoading('consig', `/contrato/AtualizaBeneficioContratosAsync/${entidadeId}`, 'PATCH')
}

export async function limpaCachePedidoAndOrcamento ({ id }) {
  return sessaoFetchLoading('base', `/pedido/${id}/limpaCachePedidoAndOrcamento`)
}

export async function filaAtualizaContratos ({ entidade_id: entidadeId, id: pedidoId }) {
  return sessaoFetchLoading('consig', `/contrato/FilaAtualizaContratos/${entidadeId}/${pedidoId}`, 'POST')
}

export async function verificaFila (dados) {
  return sessaoFetch('base', `/pedido/verificafila/${dados.pedido}`, 'POST', dados)
}

export async function filaAtualizaContratosIgnorarData ({ entidade_id: entidadeId, id: pedidoId }) {
  return sessaoFetchLoading('consig', `/contrato/FilaAtualizaContratosIgnorarData/${entidadeId}/${pedidoId}`, 'POST')
}

export async function getLeadsTodos (dados) {
  return sessaoFetchLoading('consig', '/leads/ListarTodosPaginadoQueryEnvelopado?' + serialize(dados))
}

export async function filaGetLeadsTodos (dados) {
  return sessaoFetchLoading('consig', '/RelatorioLeads/FilaListarTodosPaginadoQueryEnvelopado?' + serialize(dados))
}

export async function hangfireStatistics () {
  return sessaoFetchLoading('consig', `/hangfirestats/Statistics`)
}

export async function deletaCache (dados) {
  return sessaoFetch('base', `/pedido/deletaCache/${dados.id}`, 'GET')
}

export async function atualizaNomeFGTS (dados) {
  return sessaoFetch('base', `/pedido/atualizaNomeFGTS/${dados}`, 'GET')
}

export async function buscaTelefonesOffline (dados) {
  return sessaoFetch('base', `/entidade/telefones/${dados}`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/pedido.js